import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PgContentBlocksModule } from '../pg-content-blocks/pg-content-blocks.module';
import { PgFieldGridColumnDirective } from './pg-field-grid/pg-field-grid-column.directive';
import { PgFieldGridRowComponent } from './pg-field-grid/pg-field-grid-row/pg-field-grid-row.component';
import { PgFieldGridSubscriptComponent } from './pg-field-grid/pg-field-grid-subscript/pg-field-grid-subscript.component';
import { PgFieldGridComponent } from './pg-field-grid/pg-field-grid.component';
import { PG_FIELD_OPTIONS_DEFAULT_PROVIDER } from './pg-field-options';
import {
  PgFieldBottomBorderGapDirective,
  PgFieldPrefixDirective,
  PgFieldSubscriptDirective,
  PgFieldSuffixDirective,
  PgFieldSuperscriptDirective,
  PgFieldTopBorderGapDirective,
} from './pg-field-transclusion-slots';
import { PgFieldComponent } from './pg-field.component';
import { PgInputFactoryComponent } from './pg-input-factory/pg-input-factory.component';
import { PgInputSanitizerDirective } from './pg-input-sanitizer/pg-input-sanitizer.directive';
import { PgInputDirective } from './pg-input/pg-input.directive';
import { PgSecureInputDirective } from './pg-input/pg-secure-input.directive';
import { PgPrefixIconDirective } from './pg-prefix-icons/pg-prefix-icon.directive';
import { PgPrefixIconsComponent } from './pg-prefix-icons/pg-prefix-icons.component';
import { PgErrorDirective } from './pg-subscript-messages/pg-error.directive';
import { PgHintDirective } from './pg-subscript-messages/pg-hint.directive';
import { PG_SUBSCRIPT_STATE_CONTROLLER_PROVIDER } from './pg-subscript-messages/pg-subscript-controller';
import { PgSubscriptMessagesComponent } from './pg-subscript-messages/pg-subscript-messages.component';
import { PG_SUBSCRIPT_RENDERER_PROVIDER } from './pg-subscript-messages/pg-subscript-renderer';
import { PgSuffixIconDirective } from './pg-suffix-icons/pg-suffix-icon.directive';
import { PgSuffixIconsComponent } from './pg-suffix-icons/pg-suffix-icons.component';
import { PgIconModule } from '../pg-icon/pg-icon.module';
import { PgCalendarModule } from '../pg-calendar/pg-calendar.module';
import { PgDropDownModule } from '../pg-drop-down/pg-drop-down.module';
import { PgSpinnerModule } from '../pg-spinner/pg-spinner.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { PgStateSelectInputComponent } from './pg-state-select-input/pg-state-select-input.component';
@NgModule({
  imports: [
    CommonModule,
    PgContentBlocksModule,
    PgIconModule,
    PgCalendarModule,
    PgDropDownModule,
    PgSpinnerModule,
    ReactiveFormsModule,
    TextMaskModule,
  ],
  declarations: [
    PgFieldComponent,
    PgFieldSubscriptDirective,
    PgFieldSuperscriptDirective,
    PgFieldSuffixDirective,
    PgFieldPrefixDirective,
    PgFieldTopBorderGapDirective,
    PgFieldBottomBorderGapDirective,
    PgSubscriptMessagesComponent,
    PgHintDirective,
    PgErrorDirective,
    PgSuffixIconsComponent,
    PgPrefixIconsComponent,
    PgSuffixIconDirective,
    PgPrefixIconDirective,
    PgFieldGridComponent,
    PgFieldGridRowComponent,
    PgFieldGridColumnDirective,
    PgInputDirective,
    PgInputSanitizerDirective,
    PgFieldGridSubscriptComponent,
    PgSecureInputDirective,
    PgInputFactoryComponent,
    PgStateSelectInputComponent,
  ],
  exports: [
    PgFieldComponent,
    PgFieldSubscriptDirective,
    PgFieldSuperscriptDirective,
    PgFieldSuffixDirective,
    PgFieldPrefixDirective,
    PgFieldTopBorderGapDirective,
    PgFieldBottomBorderGapDirective,
    PgSubscriptMessagesComponent,
    PgHintDirective,
    PgErrorDirective,
    PgSuffixIconsComponent,
    PgPrefixIconsComponent,
    PgSuffixIconDirective,
    PgPrefixIconDirective,
    PgFieldGridComponent,
    PgFieldGridRowComponent,
    PgFieldGridColumnDirective,
    PgInputDirective,
    PgInputSanitizerDirective,
    PgFieldGridSubscriptComponent,
    PgSecureInputDirective,
    PgContentBlocksModule,
    PgInputFactoryComponent,
    PgDropDownModule,
    PgStateSelectInputComponent,
  ],
  providers: [
    PG_SUBSCRIPT_RENDERER_PROVIDER,
    PG_SUBSCRIPT_STATE_CONTROLLER_PROVIDER,
    PG_FIELD_OPTIONS_DEFAULT_PROVIDER,
  ],
})
export class PgFieldModule {}
